/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import { motion } from 'framer-motion'
import React, { useState, useEffect, useCallback, useContext } from 'react'
import ReactModal from 'react-modal'
import { connect } from 'react-redux'
import { Link, useParams, useSearchParams } from 'react-router-dom'
import HeaderContext from '../../Components/Context/HeaderContext'
import { DistributorActions } from '../../redux/actions'
import { WishlistedProduct } from '../../redux/helper/AddWishlist'
import { distributorService } from '../../service/distributor.service'
import AllOfferProgress from './AllOfferProgress'
import CriteriaDetail from './CriteriaDetail'
import CriteriaHeaders from './CriteriaHeaders'
import NotmatchingPopup from './NotmatchingPopup'
import OfferDetailsShimmer from './OfferDetailSkeleton'
import ProductSection from './Products';
import { TitleCase } from '../../redux/helper/CamelCase'

import './style.css'
import SpecialRecurTooltip from '../../Components/SpecialRecurTooltip'
const OfferDetails = ({ ViewOffer, GetDetails, ProductList, Products, offerData, GetOfferData, cartList, specialRecurring }) => {
    const [searchParam, setSearchParam] = useSearchParams()
    const id = searchParam.get('code')
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
    } = useContext(HeaderContext);
    const [prod, setprod] = useState([]);
    const [result, setresult] = useState([])
    const [showProducts, setshowProducts] = useState(false);
    const [selectedCriteria, setselectedCriteria] = useState(0);
    const [CriteriaObj, setCriteriaObj] = useState({});
    const [responsivePopup, setresponsivePopup] = useState(false);
    const [cartProducts, setcartProducts] = useState([]);
    const [loading, setloading] = useState(true);
    const [productsloader, setproductsloader] = useState(true);
    const [specialCartList, setspecialCartList] = useState({})
    const [cartCountObj, setcartCountObj] = useState({});
    const [criteriaObject, setcriteriaObject] = useState([]);
    const [IsSameDeal, setIsSameDeal] = useState('');
    const [showNotMaching, setshowNotMaching] = useState('');
    const [notmatchingLoader, setnotmatchingLoader] = useState(false);
    const [wishlistProduct, setwishlistProduct] = useState([]);
    const [searchValue, setsearchValue] = useState('');
    const [categories, setCategories] = useState({});
    const [hover, setHover] = useState(false);
    const [eligibleLoading, setEligibleLoading] = useState(false);
    const [subsequentOrder, setSubsequetOrder] = useState(false);
    const [offerParameter, setOfferParameter] = useState('quantity')
    const [error, setError] = useState()
    const [criteriaMainObject,setCriteriaMainObject] = useState()
    const [mainObj,setMainObj] = useState()
    const [isEligible, setIsEligible] = useState({
        is_eligible: true,
    })
    const [priceRange, setpriceRange] = useState({
        minValue: 0,
        maxValue: 0
    })
    const [Size, setSize] = useState({
        LENGTH: "",
        DIAMETER: ""
    })

    const [filterParam, setFilterParam] = useState({
        LENGTH: [],
        DIAMETER: []
    })
    const initialState = {
        "deal": id,
        "criteria": selectedCriteria,
        "page": 1,
        "limit": 10,
        "search": searchValue,
        "filter": {
            "DIAMETER": undefined,
            "SIZE": undefined,
            "category": undefined
        }
    }
    // const initialState={
    //     "page":1,
    //     "limit":10,
    //     "sort": 'EXPECTED_DELIVERY_DATE asc',}
    const [payload, setpayload] = useState(initialState);
    const handleObjCreation = (items) => {
        let status = []
        const temp = { ...CriteriaObj }
        const storeproducts = offerData?.products
        items?.product_criterion.map((val, i) => {
            if (!temp[val.id]) {
                temp[val.id] = {
                    payload: initialState,
                    orderValue: 0,
                    products: storeproducts || [],
                    number_of_pages: 0,
                    cartCount: {},
                    ProductExist: status.length > 0

                }
            }
        })
        GetOfferData(temp)
        setCriteriaObj(temp);
    }

    const handleFetch = useCallback(
        async (key) => {
            GetDetails(id).then(async (res) => {
                if (!res.error && res.data.success_status) {
                    setprod(res.data?.data?.product_criterion);
                    if (specialRecurring) {
                        setSubsequetOrder(res?.data?.subsequent_order);
                        setOfferParameter(res?.data?.offer_parameter)
                        setCriteriaMainObject(res?.data)
                    }
                    setloading(false);
                    handleObjCreation(res.data.data)
                    const listwish = await WishlistedProduct();
                    setwishlistProduct(listwish)
                    let obj = { ...offerData?.items || criteria }
                    SpecialList(obj)
                }
            })
            // SpecialList()

        },
        [],
    )
    const SpecialList =
        async (objectCopy, prodcts) => {
            let product = prodcts || prod
            let special_list;
            if (specialRecurring) {
                special_list = await distributorService.CartSpecialRecurringList(id)
                setError(special_list?.data?.error_message)
                setMainObj(special_list?.data)
            } else {
                special_list = await distributorService.CartSpecialList(id);
            }
            if (!special_list.error) {
                const checkKey = Object.values(special_list.data.data)[0]
                if (Object.keys(special_list.data.data).length > 0 && checkKey?.deal !== id) {
                    setIsSameDeal([special_list.data.data][0].deal)
                } else {
                    setspecialCartList(special_list.data.data);
                    setcriteriaObject(special_list.data.criteria);

                }
            }
            let obj = objectCopy || { ...CriteriaObj }
            const list = special_list.data.data;
            let count = {};
            if (Object.keys(list).length > 0) {
                Object.keys(list).map((item) => {
                    if (count[list[item].CONCATENATED_SEGMENTS]) {
                        count[list[item].CONCATENATED_SEGMENTS] = Number(list[item].quantity) || count[list[item].CONCATENATED_SEGMENTS];
                    } else {
                        count[list[item].CONCATENATED_SEGMENTS] = Number(list[item].quantity) || 0;
                    }
                })
            }
            else {
                count = {}
            }
            setcartCountObj(count)
            obj[product[selectedCriteria]?.id].cartCount = count
            // setCriteriaObj(obj);
        }
    const handleCartCount = useCallback(
        (items, criteria, prod, id, products) => {
            const countcopy = { ...cartCountObj }
            let obj = { ...offerData?.items || criteria }
            let count = { ...cartCountObj };
            items && items.map((val) => {
                if (count[val.CONCATENATED_SEGMENTS]) {
                    count[val.CONCATENATED_SEGMENTS] = Number(count[val.CONCATENATED_SEGMENTS]);
                } else {
                    count[val.CONCATENATED_SEGMENTS] = 0;
                }
                if (countcopy[val.CONCATENATED_SEGMENTS]) {
                    countcopy[val.CONCATENATED_SEGMENTS] = Number(countcopy[val.CONCATENATED_SEGMENTS]);
                } else {
                    countcopy[val.CONCATENATED_SEGMENTS] = 0;
                }
            })
            setcartCountObj(countcopy)
            SpecialList(obj, prod)
            return obj;
        },
        [],
    )
    const handleCat = (item) => {
        let arr = [];
        item.map((val) => {
            arr.push(val.CATEGORY_CONCAT_SEGS)
        })
        return arr;
    }
    const GetProductList = useCallback(
        async (objCopy, key, payloadFromFilter) => {
            let payloadValue = payloadFromFilter ? payloadFromFilter : payload
            const obj = { ...CriteriaObj }
            if (searchValue !== '' || searchValue !== undefined) {
                payloadValue.search = searchValue === '' ? undefined : searchValue
            }
            payloadValue.criteria = selectedCriteria
            const list = await distributorService.getDealsProducts(payloadValue);
            if (!list.error && list.data.data.success_status) {
                if (list.data?.category) {
                    setCategories(list.data.category)
                    setFilterParam({ 'DIAMETER': list.data.filter_size, 'LENGTH': list.data.filter_length })
                }
                let myprod = payloadFromFilter ? [] : obj[prod[selectedCriteria]?.id]?.products || [];
                if (payloadValue?.search?.length === '' || payloadValue?.search?.length === undefined) {
                    list?.data?.data?.data.forEach(book => {
                        const idx = myprod.map((val) => val.CONCATENATED_SEGMENTS).indexOf(book.CONCATENATED_SEGMENTS)
                        if (idx === -1) {
                            myprod.push(book);
                        }
                    });
                } else {
                    myprod = list.data.data.data
                }
                obj[prod[selectedCriteria]?.id].products = myprod
                obj[prod[selectedCriteria]?.id].number_of_pages = list?.data?.data?.number_of_pages
                obj[prod[selectedCriteria]?.id].total_result = list?.data?.data?.total_result
                if (list.data.data.data.length > 0) {
                    handleCartCount(list.data.data.data, CriteriaObj, prod, selectedCriteria);
                }
                obj.products = offerData.products || []
                setCriteriaObj(obj)
                setresponsivePopup(false);
            }
            setproductsloader(false)


        },
        [showProducts, searchValue, payload],
    )

    useEffect(() => {
        setproductsloader(true);
        GetProductList()
    }, [GetProductList])

    // const isActive = (id) => [selectedCriteria].map((val)=>val.CATEGORY_CONCAT_SEGS).indexOf(id) > -1
    useEffect(() => {
        handleFetch()
    }, [handleFetch])
    const handleSuccessMessage = (name) => {
        SetSuccessMessage(name);
        setTimeout(() => {
            SetSuccessMessage('');
            setshowNotMaching('');
            setcolorValue(false);
        }, 1000)
    }
    const handleClearCart = async () => {
        const cart = await distributorService.clearCart('key');
        if (!cart.error && cart.data.success_status) {
            setIsSameDeal('')
            handleSuccessMessage(cart.data.message)
            setshowProducts(false);
            handleFetch()

        }

    }

    //special recurring changes  
    const checkEligibility = useCallback(async () => {
        try {
            setEligibleLoading(true)
            let response = await distributorService.checkEligibility(id);
            setIsEligible(response?.data);
            setEligibleLoading(false)
        } catch (error) {
            setEligibleLoading(false)
            console.log(error)
        }

    }, [])
    useEffect(() => {
        if (specialRecurring) {
            checkEligibility()
        }
    }, [])
    return (
        <>
            <>{(loading || eligibleLoading) && <OfferDetailsShimmer />}</>
            {
                (!loading && !eligibleLoading) && ViewOffer.hasOwnProperty('items') && (

                    <motion.div
                        animate={{ opacity: 1, x: 0 }}
                        initial={{ opacity: 0, x: -10 }}
                        exit={{ opacity: 0, x: -10 }}
                        transition={{ duration: 0.15 }} className="md:px-[46px] px-4 pt-2 mb-7">
                        <Link to='/offers'><p className="text-[#090406] font-normal text-xs2">{`Offers > ${ViewOffer?.items?.offer_code}`}</p></Link>
                        <div className="flex lg:flex-nowrap flex-wrap">
                            <div className="w-full">
                                <div className="flex items-center mt-2.5 w-full">
                                    <img src="/images/related-offer.svg" alt="icon" className="w-[76px] h-[76px] flex items-center sm:block hidden" />
                                    <div className="sm:pl-[26px] pl-2 w-full">
                                        <div className="flex justify-between sm:flex-row flex-col">
                                            <p className="font-bold text-[#000000] sm:text-xs15 text-lg">{ViewOffer?.items?.offer_code}</p>
                                            <ul className="flex items-center">
                                                <li>
                                                    <button type="button" className="text-xs font-semibold text-[#FFFFFF] bg-[#44445E] rounded px-2 py-1 w-fit">{ViewOffer?.items?.offer_type}</button>
                                                </li>
                                                <li className="ml-2">
                                                    <button type="button" className="text-xs font-semibold text-[#FFFFFF] bg-[#44445E] rounded px-2 py-1 w-fit">{ViewOffer?.items?.industrial_pocket}</button>
                                                </li>
                                            </ul>
                                        </div>
                                        <p className="text-[#44445E] font-normal sm:text-xs9 text-base pt-3">Validity: <span className="text-[#000000] font-semibold sm:text-xs9 text-base"> {ViewOffer?.items?.start_date.split('-').reverse().join('/')} - {ViewOffer?.items?.end_date.split('-').reverse().join('/')}</span>{ViewOffer?.items?.offer_type === 'Special' && (<><span className="px-2">|</span><span className="text-[#000000] font-semibold sm:text-xs9 text-base" >{ViewOffer?.items?.dap_config === true ? 'DAP Applicable' : 'FOR' || 'DAP Applicable'} </span><span>|</span> <span className="text-[#000000] font-semibold sm:text-xs9 text-base">{ViewOffer?.items?.trade_eub === true ? 'Trade EUB Applicable' : ''}</span></>)}</p>
                                        <p className="text-[#44445E] font-normal sm:text-xs7 text-sm pt-4">{ViewOffer?.items?.description} </p>
                                        {ViewOffer?.items?.offer_type === "Special Recurring" && <div>
                                            <div className="flex items-center pt-4 pl-0 ">
                                                <img src="/images/note.svg" alt="icon" className="cursor-pointer" onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)} />
                                                <p className="font-semibold sm:text-sm text-sm text-[#555259] pl-1">Reset Period</p>
                                                <div className='relative'>
                                                    {hover && <SpecialRecurTooltip hover={hover} />}
                                                </div>

                                                {/* <p className="text-[#ED1C24]">* <span className="font-semibold text-[#808285] sm:text-base text-sm">*Criteria(s) is/are mandatory to be complied in term of quantity or value, whichever is applicable.</span></p> */}
                                            </div>
                                            <div className='flex mt-3 w-[70%]'>
                                                <div className='w-1/2 flex'>
                                                    <div className='w-1/2'>
                                                        <p className='text-[#808285] text-sm font-semibold'>Start Day</p>
                                                        <p className='text-[#555259] text-base font-semibold'>{ViewOffer?.items?.start_day}</p>
                                                    </div>
                                                    <div className='w-1/2'>
                                                        <p className='text-[#808285] text-sm font-semibold'>End Day</p>
                                                        <p className='text-[#555259] text-base font-semibold'>{ViewOffer?.items?.end_day}</p>
                                                    </div>
                                                </div>
                                                <div className='w-1/2 '>
                                                    <div className=' flex'>
                                                        <div className='w-1/2'>
                                                            <p className='text-[#808285] text-sm font-semibold'>Minimum {TitleCase(ViewOffer?.items?.offer_parameter)} Cap</p>
                                                            <p className='text-[#555259] text-base font-semibold'>{ViewOffer?.items?.minimum_cap}</p>
                                                        </div>
                                                        <div className='w-1/2'>
                                                            <p className='text-[#808285] text-sm font-semibold'>Maximum {TitleCase(ViewOffer?.items?.offer_parameter)} Cap</p>
                                                            <p className='text-[#555259] text-base font-semibold'>{ViewOffer?.items?.maximum_cap}</p>
                                                        </div>
                                                    </div>
                                                    <div className='flex items-center mt-2 '>
                                                        <img src="/images/note.svg" alt="icon" className="cursor-pointer" />
                                                        <p className="font-semibold sm:text-sm text-sm text-[#555259] pl-1">Note: Based on the primary UOM of the item</p>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>}

                                    </div>

                                </div>

                                <div className="flex items-start pt-4 sm:pl-[102px] pl-0 note1">
                                    <img src="/images/note.svg" alt="icon" className="pt-1" />
                                    <p className="font-semibold sm:text-sm text-sm text-[#555259] pl-1">Note: </p>
                                    <p className="text-[#ED1C24]">* <span className="font-semibold text-[#808285] sm:text-base text-sm">*Criteria(s) is/are mandatory to be complied in term of quantity or value, whichever is applicable.</span></p>
                                </div>
                                {specialRecurring && !isEligible?.is_eligible && <div className='flex mt-5 sm:pl-[102px] pl-0'>
                                    <img src="/images/note.svg" alt="icon" className="cursor-pointer" />
                                    <p className="font-semibold text-red-600  sm:text-base   pl-1">{isEligible?.message || '-'}</p>
                                </div>}
                                {specialRecurring && isEligible?.is_eligible && <div className='flex mt-5 sm:pl-[102px] pl-0'>
                                    <img src="/images/note.svg" alt="icon" className="cursor-pointer" />
                                    <p className="font-semibold text-[#555259]  sm:text-base   pl-1">{isEligible?.message || '-'}</p>
                                </div>}
                                {specialRecurring && error && <div className='flex mt-5 sm:pl-[102px] pl-0'>
                                    <img src="/images/note.svg" alt="icon" className="cursor-pointer" />
                                    <p className="font-semibold text-red-600  sm:text-base   pl-1">{error || '-'}</p>
                                </div>}
                            </div>
                            <AllOfferProgress
                                CriteriaObj={CriteriaObj}
                                prodItem={criteriaObject}
                                GetCartItems={handleFetch}
                                setCriteriaObj={setCriteriaObj}
                                selectedCriteria={selectedCriteria}
                                GetOfferData={GetOfferData}
                                ViewOffer={ViewOffer}
                                offerData={offerData}
                                initialState={initialState}
                                GetProductList={GetProductList}
                                responsivePopup={responsivePopup}
                                setresponsivePopup={setresponsivePopup}
                                cartList={cartList}
                                specialCartList={specialCartList}
                                ViewData={offerData}
                                setcartProducts={setcartProducts}
                                handleFetch={handleFetch}
                                cartProducts={cartProducts}
                                isEligible={isEligible}
                                subsequentOrder={subsequentOrder}
                                offerParameter={offerParameter}
                                criteriaMainObject={criteriaMainObject}
                                mainObj={mainObj}
                                specialRecurring={specialRecurring} />
                        </div> 
                        <CriteriaHeaders
                            ViewOffer={ViewOffer}
                            selectedCriteria={selectedCriteria}
                            setselectedCriteria={setselectedCriteria}
                            setsearchValue={setsearchValue}
                            setshowProducts={setshowProducts} />
                        <div className="tab-content w-full h-[400px]" id="pills-tabContentVertical">
                            <div className="tab-pane fade show active w-full" id="home3" role="tabpanel" aria-labelledby="pill3">
                                <div className="bg-[#F5F5FA] rounded-lg border-2 border-[#E9EDF4] mt-[30px]">
                                    <CriteriaDetail ViewOffer={ViewOffer} selectedCriteria={selectedCriteria} />
                                </div>
                                {showProducts && <div className="flex justify-end items-center mt-4 cursor-pointer hide-products" onClick={() => setshowProducts(false)}>
                                    <p className="text-[#44445E] font-normal text-xs2">Hide Products</p>
                                    <img src="/images/chevron-down1.svg" alt="icon" className="ml-1" />
                                </div>}
                                <div className={`products  ${!showProducts ? 'hidden' : ''}`} >
                                    <div className="flex w-full mt-6 lg:flex-nowrap flex-wrap pb-6">
                                        {showProducts &&
                                            <>{ViewOffer?.items?.product_criterion.map((item, i) => (
                                                selectedCriteria === i && (
                                                    <div className="lg:min-w-[75%] w-full sm:mr-5 mr-0" key={i}>
                                                        <ProductSection
                                                            setsearchValue={setsearchValue}
                                                            CriteriaObj={CriteriaObj}
                                                            prodItem={prod}
                                                            GetCartItems={GetProductList}
                                                            setCriteriaObj={setCriteriaObj}
                                                            selectedCriteria={selectedCriteria}
                                                            setselectedCriteria={setselectedCriteria}
                                                            GetOfferData={GetOfferData}
                                                            ViewOffer={ViewOffer}
                                                            offerData={offerData}
                                                            initialState={initialState}
                                                            GetProductList={GetProductList}
                                                            responsivePopup={responsivePopup}
                                                            setresponsivePopup={setresponsivePopup}
                                                            prod={prod}
                                                            setcartProducts={setcartProducts}
                                                            cartProducts={cartProducts}
                                                            offerId={id}
                                                            productsloader={productsloader}
                                                            SpecialList={SpecialList}
                                                            cartCountObj={cartCountObj}
                                                            specialCartList={specialCartList}
                                                            setshowProducts={setshowProducts}
                                                            criteriaObject={criteriaObject}
                                                            handleCat={handleCat}
                                                            showNotMaching={showNotMaching}
                                                            setshowNotMaching={setshowNotMaching}
                                                            wishlistProduct={wishlistProduct}
                                                            setloading={setloading}
                                                            result={result}
                                                            setresult={setresult}
                                                            categories={categories}
                                                            setcartCountObj={setcartCountObj}
                                                            Size={Size}
                                                            setSize={setSize}
                                                            priceRange={priceRange}
                                                            setpriceRange={setpriceRange}
                                                            setproductsloader={setproductsloader}
                                                            IsSameDeal={IsSameDeal}
                                                            filterParam={filterParam}
                                                            specialRecurring={specialRecurring}
                                                            criteriaMainObject={criteriaMainObject}
                                                            subsequentOrder={subsequentOrder}
                                                        />
                                                    </div>
                                                )
                                            ))}</>
                                        }</div>
                                </div>
                                {!showProducts && <div className="flex justify-center mt-10" >
                                    <button type="button" disabled={!(isEligible?.is_eligible)} onClick={() => (isEligible?.is_eligible) && setshowProducts(true)} className={`w-[210px] h-10 ${!(isEligible?.is_eligible) ? 'bg-[#A5A5A5]' : 'bg-[#555259]'} rounded-lg text-sm text-[#FFFFFF] font-semibold view-products`}>
                                        View Products
                                    </button>
                                </div>}
                            </div>
                        </div>
                        <ReactModal style={{ overFlow: 'auto' }} isOpen={showNotMaching !== ''}>
                            <NotmatchingPopup
                                setremovePopup={setshowNotMaching}
                                handleClearCart={handleClearCart}
                                loading={notmatchingLoader}
                                setremoveLoader={setnotmatchingLoader}
                            />
                        </ReactModal>
                    </motion.div>
                )
            }</>

    )
}
const mapStateToProps = (state) => {
    const { Cart, ViewOffer, Products, offerData } = state;
    return { Cart, ViewOffer, Products, offerData }

};

const mapDispatchToProps = {
    GetDetails: DistributorActions.GetOfferDetails,
    ProductList: DistributorActions.ProductListing,
    GetOfferData: DistributorActions.GetOfferData,
    cartList: DistributorActions.GetCartItems

}
export default connect(mapStateToProps, mapDispatchToProps)(OfferDetails)